/**
 * All the flags Identity subscribes to from Launch Darkly.
 *
 * Flags could be created in Launch Darkly as camelCase or kebab-case. Identity
 * is only supporting camelCase so make sure flags are using that convention
 * when created in Launch Darkly.
 */
export const subscribedFlags = {
  paymentOwnsReportsV2: false,
  paymentsPlatformFeeEnforcement: false,
  // Same flag payment-service gates Billing notification sends on; here it
  // gates the Billing section of the notification-preferences page.
  paymentsBillingNotificationsSend: false,
  identityUpdateRoles: false,
  // Gates the Zendesk-embed popup auth UI on /login (EmbeddedLogin). Ships
  // dormant; flip on in a real IAP environment to validate the popup flow.
  zendeskEmbedPopupAuth: false,
  txmLeadTransactionAccess: false,
  partnerMapForExternalBrokers: false,
};

export type SubscribedFlags = typeof subscribedFlags;
export type SubscribedFlag = keyof SubscribedFlags;
